<template>
    <VContainer>
        <v-card v-if="event">
            <VCardTitle class="headline font-weight-light">
                {{event.name}} By Id
            </VCardTitle>
            <VCardText>
                <VLayout wrap>
                    <VFlex>
                        <img :src="event.imgurl" height="200" />
                    </VFlex>
                    <VFlex>
                        {{event.description}}
                    </VFlex>
                </VLayout>
                <VLayout wrap>
                    <VFlex>
                        <span class="title font-weight-light">Select to register</span>
                    </VFlex>
                    <VFlex xs12>
                        <v-list>
                            <v-list-item v-for="(a,i) in skus" :key="i" to="/registrationbyid" >
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{a.attributes.name}} ${{a.price/100}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{a.metadata.date}}  {{a.metadata.time}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action >
                                    <v-btn icon>
                                        <v-icon>
                                            {{$store.state.icons.checkon}}
                                        </v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </VFlex>
                </VLayout>
            </VCardText>
        </v-card>
    </VContainer>
</template>

<script>
  import {
    mapActions,
    mapMutations,
    mapState
  } from 'vuex'
  import BaseBtn from "../BaseBtn";
  export default {
    props:['eventid'],
    components: {BaseBtn},
    name: "RegistrationById",
    data() {
      return {
        loading:false,
        activeplan:0,
        activesubscription:false,
        confirmsubscribedialog:false,
        unsubscribedialog:false
      }
    },
    mounted() {
    },
    computed:{
      ...mapState(['activeevent','orders','activesku']),
      event(){
        return this.activeevent.event
      },
      skus(){
        return this.activeevent.skus
      },
      product(){
        return this.activeevent.product
      }
    },
    watch:{
      customer(){
        this.loading = false
      }
    },
    methods: {
      ...mapActions(['getCustomer']),
      getEvent() {
        let em = this;
        this.$store.dispatch('openGet',{body:'',path: 'api/event/json/'+this.eventid})
            .then(res=>{
              em.$store.commit('setEvent', res)
            }).catch(e=>{console.log(e)})
      }
    }
  }
</script>

<style scoped>

</style>